import { render, staticRenderFns } from "./DebugMenu.vue?vue&type=template&id=3abf0a41"
import script from "./DebugMenu.vue?vue&type=script&lang=js"
export * from "./DebugMenu.vue?vue&type=script&lang=js"
import style0 from "./DebugMenu.vue?vue&type=style&index=0&id=3abf0a41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports